import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'highlight';
}
export function Card({
  children,
  className = '',
  variant = 'default'
}: CardProps) {
  const baseStyles = 'rounded-2xl p-6 md:p-8 transition-all duration-300';
  const variants = {
    default: 'bg-white shadow-sm border border-[#EBE5DE]',
    highlight: 'bg-[#F5F1EB] border border-[#EBE5DE] shadow-md'
  };
  return <div className={`${baseStyles} ${variants[variant]} ${className}`} data-id="element-235">
      {children}
    </div>;
}